import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
  Toast,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useDispatch } from "react-redux";

import avatar from "../../assets/images/users/user-dummy-img.jpg";
// actions
import { editUsers } from "../../slices/thunks";
import { updateChannelsAdded } from "../../apiCalls/caller";
import { toast } from "react-toastify";

import { getLoggedinUser, setUserData } from "../../utils/StorageManager";

const CHANNEL_OPTIONS = [
  { key: "amazon", label: "Amazon" },
  { key: "ebay", label: "eBay" },
  { key: "walmart", label: "Walmart" },
];

const UserProfile = () => {
  const dispatch = useDispatch();
  const [email, setemail] = useState("admin@gmail.com");
  const [idx, setidx] = useState("1");
  const [userName, setUserName] = useState("Admin");
  const [company, setCompany] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [sellerCluodId, setSellerCloudId] = useState(0);
  const [cartonCloudID, setCartonCloudID] = useState("");
  const userProfileSession = getLoggedinUser();

  // --- Sales Channels state ---
  const { channels: _initChannels, savedOthers: _initSavedOthers } = (() => {
    const savedStr = userProfileSession?.user_channelsAdded ?? "";
    const keys = savedStr ? savedStr.split(",").map((s) => s.trim()).filter(Boolean) : [];
    const known = new Set(CHANNEL_OPTIONS.map((c) => c.key));
    const init = {};
    const others = [];
    for (const ck of keys) {
      if (known.has(ck)) {
        init[ck] = true;
      } else if (ck) {
        init.other = true;
        others.push(ck);
      }
    }
    return { channels: init, savedOthers: others };
  })();

  const [selectedChannels, setSelectedChannels] = useState(_initChannels);
  const [savedOthers, setSavedOthers] = useState(_initSavedOthers);
  const [newOtherText, setNewOtherText] = useState("");
  const [savingChannel, setSavingChannel] = useState(false);

  // Snapshot of channels stored on server (locked = can't uncheck)
  const [savedChannelKeys, setSavedChannelKeys] = useState(() => {
    const savedStr = userProfileSession?.user_channelsAdded ?? "";
    return savedStr ? savedStr.split(",").map((s) => s.trim()).filter(Boolean) : [];
  });

  const handleChannelChange = async (key, checked) => {
    // Prevent unchecking a previously-saved channel
    if (!checked && savedChannelKeys.includes(key)) return;

    setSelectedChannels((prev) => ({ ...prev, [key]: checked }));

    // Auto-save when adding a new channel (skip "other" — needs text input first)
    if (checked && key !== "other") {
      const updatedChannels = { ...selectedChannels, [key]: true };
      const keys = CHANNEL_OPTIONS.filter((c) => updatedChannels[c.key]).map((c) => c.key);
      savedOthers.forEach((o) => keys.push(o));
      const channels = keys.join(",");
      setSavingChannel(true);
      try {
        await updateChannelsAdded({ id: idx, channels });
        toast.success("Marketplace saved!", { position: "top-center", autoClose: 2000 });
        const currentUser = getLoggedinUser();
        if (currentUser) {
          setUserData({ ...currentUser, user_channelsAdded: channels });
        }
        setSavedChannelKeys(channels.split(",").map((s) => s.trim()).filter(Boolean));
      } catch {
        toast.error("Could not save channel. Please try again.", { position: "top-center", autoClose: 3000 });
        setSelectedChannels((prev) => ({ ...prev, [key]: false }));
      } finally {
        setSavingChannel(false);
      }
    }
  };

  const saveOtherChannel = async () => {
    const text = newOtherText.trim();
    if (!text) {
      toast.error("Please enter a marketplace name.", { position: "top-center", autoClose: 2000 });
      return;
    }
    const updatedOthers = [...savedOthers, text];
    const updatedChannels = { ...selectedChannels };
    const keys = CHANNEL_OPTIONS.filter((c) => updatedChannels[c.key]).map((c) => c.key);
    updatedOthers.forEach((o) => keys.push(o));
    const channels = keys.join(",");
    setSavingChannel(true);
    try {
      await updateChannelsAdded({ id: idx, channels });
      toast.success("Marketplace saved!", { position: "top-center", autoClose: 2000 });
      const currentUser = getLoggedinUser();
      if (currentUser) {
        setUserData({ ...currentUser, user_channelsAdded: channels });
      }
      setSavedOthers(updatedOthers);
      setNewOtherText("");
      setSavedChannelKeys(channels.split(",").map((s) => s.trim()).filter(Boolean));
    } catch {
      toast.error("Could not save channel. Please try again.", { position: "top-center", autoClose: 3000 });
    } finally {
      setSavingChannel(false);
    }
  };

  useEffect(() => {
    if (userProfileSession) {
      setUserName(userProfileSession.user_name);
      setemail(userProfileSession.user_email);
      setidx(userProfileSession.user_id || "1");
      setSellerCloudId(userProfileSession.user_sellerCloudCompanyId || 0);
      setCartonCloudID(userProfileSession.user_CC_customerID || 0);
      setCity(userProfileSession.user_city || "");
      setState(userProfileSession.user_state || "");
      setZip(userProfileSession.user_zip || "");
      setCountry(userProfileSession.user_country || "");
      setCompany(userProfileSession.user_company || "");
      setAddress(userProfileSession.user_address || "");
      setTimeout(() => {}, 3000);
    }
  }, [userProfileSession]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      user_sellerCloudCompanyId: sellerCluodId || 0,
      user_CC_customerID: cartonCloudID || "",
      user_company: company || "",
      user_address: address || "",
      user_city: city || "",
      user_state: state || "",
      user_zip: zip || "",
      user_country: country || "",
    },
    validationSchema: Yup.object({
      user_sellerCloudCompanyId: Yup.number().required(
        "Please Enter Your SellerCloud Company ID"
      ),
      user_CC_customerID: Yup.string(),
      user_company: Yup.string(),
      user_address: Yup.string(),
      user_city: Yup.string(),
      user_state: Yup.string(),
      user_zip: Yup.string(),
      user_country: Yup.string(),
    }),
    onSubmit: (values) => {
      console.log(values);
      const data = {
        ...userProfileSession,
        user_sellerCloudCompanyId: values.user_sellerCloudCompanyId,
        user_CC_customerID: values.user_CC_customerID,
        user_company: values.user_company,
        user_address: values.user_address,
        user_city: values.user_city,
        user_state: values.user_state,
        user_zip: values.user_zip,
        user_country: values.user_country,
      };
      setUserData(data);
      dispatch(editUsers(data));
      // dispatch(editProfile(values));
    },
  });

  document.title = `Profile | ${process.env.REACT_APP_SITE_TITLE} `;
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{userName}</h5>
                        <p className="mb-1">Email Id : {email}</p>
                        <p className="mb-0">Id #:{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group mb-3">
                  <Label className="form-label">SellerCloud Company ID</Label>
                  <Input
                    name="user_sellerCloudCompanyId"
                    id="user_sellerCloudCompanyId"
                    className="form-control"
                    placeholder="Enter your SellerCloud Company ID"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.user_sellerCloudCompanyId || ""}
                    invalid={
                      validation.touched.user_sellerCloudCompanyId &&
                      validation.errors.user_sellerCloudCompanyId
                        ? true
                        : false
                    }
                  />
                  {validation.touched.user_sellerCloudCompanyId &&
                  validation.errors.user_sellerCloudCompanyId ? (
                    <FormFeedback type="invalid">
                      {validation.errors.user_sellerCloudCompanyId}
                    </FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <div className="form-group mb-3">
                  <Label className="form-label">CartonCloud Company ID</Label>
                  <Input
                    name="user_CC_customerID"
                    id="user_CC_customerID"
                    className="form-control"
                    placeholder="Enter your CartonCloud Company ID"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.user_CC_customerID || ""}
                    invalid={
                      validation.touched.user_CC_customerID &&
                      validation.errors.user_CC_customerID
                        ? true
                        : false
                    }
                  />
                  {validation.touched.user_CC_customerID &&
                  validation.errors.user_CC_customerID ? (
                    <FormFeedback type="invalid">
                      {validation.errors.user_CC_customerID}
                    </FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="user_company">Company</Label>
                      <Input
                        id="user_company"
                        name="user_company"
                        type="text"
                        value={validation.values.user_company}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter company"
                        invalid={
                          validation.touched.user_company &&
                          validation.errors.user_company
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_company &&
                      validation.errors.user_company ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_company}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="user_address">Address</Label>
                      <Input
                        id="user_address"
                        name="user_address"
                        type="text"
                        value={validation.values.user_address}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter address"
                        invalid={
                          validation.touched.user_address &&
                          validation.errors.user_address
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_address &&
                      validation.errors.user_address ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_address}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="user_city">City</Label>
                      <Input
                        id="user_city"
                        name="user_city"
                        type="text"
                        value={validation.values.user_city}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter city"
                        invalid={
                          validation.touched.user_city &&
                          validation.errors.user_city
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_city &&
                      validation.errors.user_city ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_city}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="user_state">State</Label>
                      <Input
                        id="user_state"
                        name="user_state"
                        type="text"
                        value={validation.values.user_state}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter state"
                        invalid={
                          validation.touched.user_state &&
                          validation.errors.user_state
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_state &&
                      validation.errors.user_state ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_state}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="user_country">Country</Label>
                      <Input
                        id="user_country"
                        name="user_country"
                        type="text"
                        value={validation.values.user_country}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter country"
                        invalid={
                          validation.touched.user_country &&
                          validation.errors.user_country
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_country &&
                      validation.errors.user_country ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_country}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <div className="mb-3">
                      <Label htmlFor="user_zip">Zip</Label>
                      <Input
                        id="user_zip"
                        name="user_zip"
                        type="text"
                        value={validation.values.user_zip}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="Enter zip"
                        invalid={
                          validation.touched.user_zip &&
                          validation.errors.user_zip
                            ? true
                            : false
                        }
                      />
                      {validation.touched.user_zip &&
                      validation.errors.user_zip ? (
                        <FormFeedback type="invalid">
                          {validation.errors.user_zip}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <div className=" mt-4">
                  <Button type="submit" color="success">
                    Save
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>

          {userProfileSession?.user_freeType !== "trial" && (
          <Card>
            <CardBody>
              <h5 className="card-title mb-3">Sales Channels</h5>
              <p className="text-muted">
                Select additional marketplace(s) to connect:
              </p>
              <div className="border rounded p-3 bg-light">
                <Row>
                  <Col md={6}>
                    {CHANNEL_OPTIONS.map(({ key, label }) => (
                      <FormGroup check key={key} className="mb-1">
                        <Input
                          type="checkbox"
                          id={`profile-channel-${key}`}
                          checked={!!selectedChannels[key]}
                          disabled={savingChannel || savedChannelKeys.includes(key)}
                          onChange={(e) =>
                            handleChannelChange(key, e.target.checked)
                          }
                        />
                        <Label check htmlFor={`profile-channel-${key}`}>
                          {label}
                        </Label>
                      </FormGroup>
                    ))}
                    <FormGroup check className="mb-1">
                      <Input
                        type="checkbox"
                        id="profile-channel-other"
                        checked={savedOthers.length > 0}
                        disabled
                      />
                      <Label check htmlFor="profile-channel-other">
                        Other{savedOthers.length > 0 && ":"}
                        {savedOthers.map((name, i) => (
                          <span key={i} className="badge bg-soft-primary text-primary ms-1">
                            {name}
                          </span>
                        ))}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <Label className="fw-medium mb-2">Add additional marketplace</Label>
                    <div className="d-flex align-items-center gap-2">
                      <Input
                        type="text"
                        placeholder="Specify marketplace…"
                        value={newOtherText}
                        onChange={(e) => setNewOtherText(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-primary btn-sm text-nowrap"
                        disabled={savingChannel || !newOtherText.trim()}
                        onClick={saveOtherChannel}
                      >
                        {savingChannel ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
